import React, { useEffect, useState } from "react";
import "./TabView.css";

type Props = {
  children: { [index: string]: React.ReactNode };
  defaultSelectedIndex: number;
  style?: React.CSSProperties;
  needResetActveTab?: boolean;
  setNeedResetActiveTab?: (need: boolean) => void;
  headerRightSideButton?: React.ReactNode;
  onChangeTab?: () => void;
};

export default function TabView({
  children,
  defaultSelectedIndex,
  style = {},
  needResetActveTab = false,
  setNeedResetActiveTab = () => {},
  headerRightSideButton = null,
  onChangeTab = () => {}
}: Props) {
  const headers = Object.keys(children);
  const [activeTab, setActiveTab] = useState(headers[defaultSelectedIndex]);

  const onTabClicked = (header: string) => {
    setActiveTab(header);
    onChangeTab();
  };

  useEffect(() => {
    if (needResetActveTab) {
      setActiveTab(headers[defaultSelectedIndex]);
      setNeedResetActiveTab(false);
    }
  }, [needResetActveTab]);

  const headerViews = (
    <div className="tab-header-container">
      <div className="tab-header-tabs">
        {headers.map((header) => {
          return (
            <div
              key={"tab-header-key-" + header}
              className={
                header === activeTab ? "tab-header tab-active" : "tab-header"
              }
              onClick={() => onTabClicked(header)}
            >
              {header}
            </div>
          );
        })}
      </div>
      {headerRightSideButton !== null && (
        <div className="tab-header-right-buttons">{headerRightSideButton}</div>
      )}
    </div>
  );
  return (
    <div className="tab-view" style={{ ...style }}>
      {headerViews}
      {children[activeTab]}
    </div>
  );
}
